import { render, staticRenderFns } from "./RegistrationConfirm.vue?vue&type=template&id=1e92a512&scoped=true&"
import script from "./RegistrationConfirm.vue?vue&type=script&lang=js&"
export * from "./RegistrationConfirm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationConfirm.vue?vue&type=style&index=0&id=1e92a512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e92a512",
  null
  
)

component.options.__file = "RegistrationConfirm.vue"
export default component.exports